let played = false;
try {
    played = !!sessionStorage.getItem("cs_intro_seen");
    if (!played) sessionStorage.setItem("cs_intro_seen", "1");
} catch (e) {
    played = true;
}

export const INTRO_DELAY = played ? 0 : 2.3;
